
const digest = 'b5c7fe1056be36d1b7031a9599a7b80bf0392ecf59e596ee5a23d2d6a1dd629a';
const classes = {"wrapper":"_wrapper_frtce_1","text":"_text_frtce_4","text2":"_text2_frtce_8","buttonWrapper":"_buttonWrapper_frtce_13"};
const css = `._wrapper_frtce_1 {
  text-align: center;
}
._wrapper_frtce_1 ._text_frtce_4 {
  margin-top: 20px;
  color: #ffffff;
}
._wrapper_frtce_1 ._text2_frtce_8 {
  margin-top: 40px;
  font-size: 16px;
  color: #212357;
}
._wrapper_frtce_1 ._buttonWrapper_frtce_13 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  